module.exports = "/ee6905bb4609431ff472c908bc4fa891.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/brands/tanqueray.png
 ** module id = 2209
 ** module chunks = 0
 **/